import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button, Form } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

import { useNavigate } from 'react-router-dom';
const CustomersTable = ({ customers, setIdCustomerEdit, setOpenModal }) => {
  const history = useNavigate();

  const columns = [
    {
      accessorKey: 'clave',
      header: 'Clave',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'razonsocial',
      header: 'Razon Social',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'rfc',
      header: 'RFC',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'status.descripcion',
      header: 'Activo',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' },
      cell: ({ row }) => {
        return (
          <div>
            <Form.Check
              checked={
                row.original.status.descripcion === 'ACTIVO' ? true : false
              }
            />
          </div>
        );
      }
    },
    {
      accessorKey: 'idcliente',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idcliente } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              className="me-2"
              onClick={() => {
                setIdCustomerEdit(idcliente);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                history(
                  '/administration/detallecliente/?idcustomer=' + idcliente
                );
              }}
            >
              <FontAwesomeIcon icon="search" />
            </Button>
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={customers}
        title="Clientes"
        columns={columns}
        addAction={() => {
          setIdCustomerEdit(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};
CustomersTable.propTypes = {
  customers: PropTypes.array.isRequired,
  setIdCustomerEdit: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};
export default CustomersTable;
